import { render, staticRenderFns } from "./CreatingAccountModal.vue?vue&type=template&id=bde5dc32&"
import script from "./CreatingAccountModal.vue?vue&type=script&lang=js&"
export * from "./CreatingAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports